import React, { useEffect, useState, useRef } from "react";
import {
    makeAjax,
    showMessage,
    url,
    respStatus,
    dotNumberValidation,
    dotNumberBlurValidation,
    withDotValidation,
} from "../../../../../helpers/global_helper";
import BetSuccessPopup from "../../../../Popups/BetSuccessPopup";
import ConfirmBetDeskonPopup from "../../../../Popups/ConfirmBetDeskonPopup";
import { useSelector, useDispatch } from "react-redux";
import ErrorPopup from "../../../../Popups/ErrorPopup";
import ErrorInnerPopup from "../../../../Popups/ErrorInnerPopup";
import ConfirmDataBetDeskonPopup from "../../../../Popups/ConfirmDataBetDeskonPopup";
import { FaBullseye, FaLeaf } from "react-icons/fa";
import CancelledBetDeskonPopup from "../../../../Popups/CancelledBetDeskonPopup";
import { withTranslation } from "react-i18next";
import { formatPrice } from "../../../../NumberFormat";
import {
    getUserBalance,
    setCommonConfig,
} from "../../../../../redux/actions";
import GameClosedPopup from "../../GameClosedPopup";
import MarketClose from "../../MarketClose";
import { mobileTotalBetCalculate } from "../../FourD/FourDThreeDTwoD/MobileTotalBetCalcy";
import CommonBetHeader from "../../CommonBetHeader";
import CoachMarkPopup from "../../../../Popups/CoachMarkPopup";

const Bet_Full = (props) => {
    const totaldiv = useRef();
    const guessRef = useRef(null);
    const autoBetRef = useRef(null);
    const bbRef = useRef(null);
    const resetRef = useRef(null);
    const dispatch = useDispatch();
    const device = useSelector((state) => state.CommonConfig.device_type);
    const gameId = useSelector((state) => state.CommonConfig.gameId);
    const betDiscount = useSelector((state) => state.CommonConfig.discount);
    const user_balance = useSelector((state) => state.UserBalance.user_balance);
    const [dicountValue, setDiscountValue] = useState();
    const [maxAmountValue, setMaxtAmountValue] = useState();
    const [minAmountValue, setMinAmountValue] = useState();
    const [rowsToShow, setRowsToShow] = useState(0);
    const [successPopup, setSuccessPopup] = useState(false);
    const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
    const [showCancelledPopup, setShowCancelledPopup] = useState(false);
    const [showConfirmationDataPopup, setShowConfirmationDataPopup] =
        useState(false);
    const [inputToShow, setInputToShow] = useState(4);
    const [respData, setRespData] = useState([]);
    const [values, setValues] = useState([]);
    const [angaka, setAngaka] = useState([]);
    const [angakaBB, setAngakaBB] = useState([]);
    const [rowInd, setRowInd] = useState(0);
    const [newIndexFocus, setNewIndexFocus] = useState("");
    const [showGameClose, setShowGameClose] = useState(false);
    const [showMarketClose, setShowMarketClose] = useState(false);
    const [isPopupShown, setIsPopupShown] = useState(false);
    const initialAngaka = {
        isfullbet: null,
        gameId: null,
        gameType: "5D6D",
        dfp: "fullbet",
        action: "process",
        betTogelAuth: "betTogelAuth",
        allowPartner: "allowPartner",
        dataangka: [],
    };
    const [reqData, setReqData] = useState(initialAngaka);
    const [newAngakaD, setNewAngakaD] = useState([]);
    const [newReqData, setNewReqData] = useState(initialAngaka);
    const [reqBBData, setReqBBData] = useState(initialAngaka);

    const colRef = useRef({});
    const [bets, setBets] = useState({});
    const [belliBets, setBelliBets] = useState({});
    const [diskon, setDiskon] = useState({});
    const [bolakBalik, setBolakBalik] = useState({});
    const [belli, setBbelli] = useState({});
    const [probabilityTable, setProbabilityTable] = useState(false);
    const [mainButton, setMainButton] = useState(true);
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const [errMessage, setErrorMessage] = useState("");
    const [succMessage, setSuccessMessage] = useState("");
    const [bolBalikRow, setBolBalikRow] = useState([]);
    const [bolBalikRowALL, setBolBalikRowAll] = useState(0);
    const [bolakBalikRespArray, setBolakBalikRespArray] = useState([]);
    const [checkedBoxes, setCheckedBoxes] = useState(
        Array(bolakBalikRespArray.length).fill(true)
    );
    const [totalAmount, setTotalAmount] = useState(0);
    const [totalBetAmount, setTotalBetAmount] = useState([]);
    const [bbPayAmount, setBBPayAmount] = useState(0);
    const [payAmount, setPayAmount] = useState(0);
    const [discountAmount, setDiscountAmount] = useState(0);
    const [mobMaxValidate, setMobMaxValidate] = useState(0);
    const [bolakBalikRespAngka, setBolakBalikRespAngka] = useState([]);
    const [defaultValue, setDefaultvalue] = useState("");
    const [defaultvalue5D, setDefaultvalue5D] = useState("");
    const [mobile4Digit, setMobile4Digit] = useState(0);
    const [betLength, setBetLength] = useState(0);
    const currentStep = useSelector((state) => state.paginationData.currentStep)

    const [beliDisabled, setBeliDisabled] = useState(
        Array(rowsToShow).fill(true)
    );
    const [beliDisabled5D, setBeliDisabled5D] = useState(
        Array(rowsToShow).fill(true)
    );
    const [beliDisabled2D, setBeliDisabled2D] = useState(
        Array(rowsToShow).fill(true)
    );
    // Mobie Usestate ============
    const [mobbets, setMobBets] = useState({});

    useEffect(() => {
        const rowCount = device === "Desktop" ? 10 : 10;
        setRowsToShow(rowCount);
    }, [device]);

    useEffect(() => {
        // if ((device === "Mobile" || device === "Desktop" || device === "Tablet") && (currentStep === 2 || currentStep === 5 ||currentStep === 6 || currentStep === 7)) {
        if ((device === "Mobile" || device === "Desktop" || device === "Tablet") && (currentStep === 6 || currentStep === 7) &&
            resetRef.current) {
            resetRef.current.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        } else if ((device === "Mobile" || device === "Desktop" || device === "Tablet") && currentStep === 2 &&
            guessRef.current) {
            guessRef.current.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        } else if ((device === "Mobile" || device === "Desktop" || device === "Tablet") && (currentStep === 6 || currentStep === 5) &&
            bbRef.current) {
            bbRef.current.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        }
    }, [currentStep, device]);

    const handleInputBlur = (e, rowIndex, inputInd) => {
        const { name, value } = e.target;
        if (device === "Desktop") {
            updateBetNumber();
            let updatedBets = { ...bets };
            let bet = updatedBets[`bets${rowIndex}`];

            if (bet !== undefined) {
                if (bet.length === 5) {
                    const newIndex = `5D-${rowIndex}`;
                    colRef.current[newIndex].focus();
                }
            }
        } else {
            updateMobileBets();
            if (value.length >= 5) {
                const newIndex = `${rowIndex}-belli`;
                colRef.current[newIndex].focus();
            }
        }
    };

    const hendleInputFocus = (e, rowIndex, inputIndex) => {
        const { name, value } = e.target;
        let updatedBets = { ...bets };
        if (
            (updatedBets[`bets${rowIndex}0`] !== "" &&
                updatedBets[`bets${rowIndex}0`] !== undefined &&
                updatedBets[`bets${rowIndex}1`] !== "" &&
                updatedBets[`bets${rowIndex}1`] !== undefined &&
                updatedBets[`bets${rowIndex}2`] === "") ||
            (updatedBets[`bets${rowIndex}2`] === undefined &&
                updatedBets[`bets${rowIndex}3`] === "" &&
                updatedBets[`bets${rowIndex}3`] === undefined &&
                rowIndex !== rowInd &&
                inputIndex === 5)
        ) {
            if (
                updatedBets[`bets${rowIndex}0`] !== "" &&
                updatedBets[`bets${rowIndex}1`] !== "" &&
                updatedBets[`bets${rowIndex}2`] !== ""
            ) {
                const newIndex = `${rowIndex}-belli`;
                colRef.current[newIndex].focus();
            }
        }
    };

    const handleInputChange = (e, rowIndex, inputInd, columnName) => {
        setRowInd(rowIndex);
        const { name, value } = e.target;
        const onlyNumbers = value.replace(/[^0-9]/g, "")
            ? value.replace(/[^0-9]/g, "")
            : "";
        const onlyNumbersMob = value.replace(/[^0-9]/g, "")
            ? value.replace(/[^0-9]/g, "")
            : "";
        let prevLength =
            device === "Desktop" ? onlyNumbers.length : onlyNumbersMob.length;
        if (onlyNumbers.length > 5 || onlyNumbersMob.length > 5) {
            setBetLength(
                device === "Desktop" ? onlyNumbers.length : onlyNumbersMob.length
            );
        }

        resetRowDataNoValue(rowIndex, prevLength);

        if (device === "Desktop") {
            let updatedBets = { ...bets };
            updatedBets[name] = onlyNumbers;
            setBets(updatedBets);
            setMobMaxValidate(0);
            mobileValidation(onlyNumbers, rowIndex, value);
        } else {
            setMobile4Digit(0); // it is use for 4th digit update in values array true = update, false = notupdate
            setMobMaxValidate(0);
            const newMobBets = {
                ...mobbets,
                [name]: onlyNumbersMob,
            };
            setMobBets(newMobBets);
            mobileValidation(onlyNumbersMob, rowIndex, value);
        }

        const updateDisabledValues = (
            beliDisabledArray,
            lengthCondition,
            rowIndex
        ) => {
            return beliDisabledArray.map((item, ind) => {
                if (ind === rowIndex) {
                    if (
                        (item === true && onlyNumbersMob.length >= lengthCondition) ||
                        (item === false && onlyNumbersMob.length < lengthCondition)
                    ) {
                        return !item; // Toggle the item
                    }
                }
                return item; // No changes for other rows
            });
        };

        if (onlyNumbersMob.length === 6) {
            const newDisabledVal = updateDisabledValues(beliDisabled, 2, rowIndex);
            setBeliDisabled(newDisabledVal);
        } else if (onlyNumbersMob.length === 5) {
            setBeliDisabled([
                ...beliDisabled.slice(0, rowIndex),
                true, // Disable this specific row
                ...beliDisabled.slice(rowIndex + 1),
            ]);
            const newDisabledVal5D = updateDisabledValues(
                beliDisabled5D,
                5,
                rowIndex
            );
            setBeliDisabled5D(newDisabledVal5D);
        }

        if (onlyNumbersMob.length == 6 || onlyNumbers.length == 6) {
            const newIndex = `${rowIndex}-belli`;
            setTimeout(() => {
                colRef.current[newIndex].focus();
            }, 0);
        }
    };

    const resetRowDataNoValue = (rowIndex, length) => {
        if (length == 2 && betLength == 6) {
            setBeliDisabled((prevBeliDis) => {
                const newBeliDisabled = [...prevBeliDis];
                newBeliDisabled[rowIndex] = true;
                return newBeliDisabled;
            });
            const newBelliBets = { ...belliBets };
            delete newBelliBets[`6D-${rowIndex}`]; // or whichever key you want
            delete newBelliBets[`5D-${rowIndex}`]; // or whichever key you want
            setBelliBets(newBelliBets);
        } else if (length == 0 || (length == 1 && betLength == 6)) {
            setValues((prevVal) => {
                const newValues = [...prevVal];
                newValues[rowIndex] = undefined;
                return newValues;
            });

            setBeliDisabled((prevBeliDis) => {
                const newBeliDisabled = [...prevBeliDis];
                newBeliDisabled[rowIndex] = true;
                return newBeliDisabled;
            });

            setBeliDisabled5D((prevBeliDis3D) => {
                const newbeliDisabled5D = [...prevBeliDis3D];
                newbeliDisabled5D[rowIndex] = true;
                return newbeliDisabled5D;
            });
            const newBelliBets = { ...belliBets };
            delete newBelliBets[`6D-${rowIndex}`]; // or whichever key you want
            delete newBelliBets[`5D-${rowIndex}`]; // or whichever key you want
            setBelliBets(newBelliBets);
        } else if (length == 6 && betLength == 6) {
            setBeliDisabled((prevBeliDis) => {
                const newBeliDisabled = [...prevBeliDis];
                newBeliDisabled[rowIndex] = false;
                return newBeliDisabled;
            });

            setBeliDisabled5D((prevBeliDis3D) => {
                const newbeliDisabled5D = [...prevBeliDis3D];
                newbeliDisabled5D[rowIndex] = false;
                return newbeliDisabled5D;
            });

            setBelliBets((prevBelli) => {
                const newBelliBets = { ...prevBelli };
                newBelliBets[`6D-${rowIndex}`] = defaultValue;
                newBelliBets[`5D-${rowIndex}`] = defaultvalue5D;
                return newBelliBets;
            });
        }
    };

    const mobileValidation = (bet, index, value) => {
        if (bet.length == 6) {
            if (defaultValue !== "" && defaultValue !== undefined) {
                if (defaultValue * betDiscount.showMultiple6dFullbet > betDiscount.showMax6dFullbet) {
                    setBelliBets((prevBeli) => {
                        const updateBelliBet = { ...prevBeli };
                        updateBelliBet[`6D-${index}`] = "";
                        return updateBelliBet;
                    });
                    setErrorMessage(props.t("you_have_reached_max_bet_value"));
                    setShowErrorPopup(true);
                    return;
                } else if (
                    defaultValue * betDiscount.showMultiple6dFullbet <
                    betDiscount.showMin6dFullbet
                ) {
                    setBelliBets({
                        ...belliBets,
                        [`6D-${index}`]: "",
                    });
                } else {
                    let newDiskon5D;
                    let value5D = defaultValue;
                    newDiskon5D =
                        value5D > 0
                            ? (value5D * betDiscount.showMultiple5dFullbet * betDiscount.showDisc6dFullbet) /
                            100
                            : 0;

                    let newBolakBalik;
                    newBolakBalik = value5D * betDiscount.showMultiple5dFullbet - newDiskon5D;
                    setBolakBalik({
                        ...bolakBalik,
                        [index]: newBolakBalik,
                    });
                    setBelliBets({
                        ...belliBets,
                        [`6D-${index}`]: defaultValue,
                    });
                }
            }
        } else if (bet.length == 5) {
            if (
                defaultValue !== "" &&
                defaultValue !== undefined &&
                belliBets[`6D-${index}`]
            ) {
                setBelliBets({
                    ...belliBets,
                    [`6D-${index}`]: "",
                });
            }
            if (defaultvalue5D !== "" && defaultvalue5D !== undefined) {
                if (
                    defaultvalue5D * betDiscount.showMultiple5dFullbet >
                    betDiscount.showMax5dFullbet
                ) {
                    setBelliBets({
                        ...belliBets,
                        [`5D-${index}`]: "",
                    });
                    setErrorMessage(props.t("you_have_reached_max_bet_value"));
                    setShowErrorPopup(true);
                    return;
                } else if (
                    defaultvalue5D * betDiscount.showMultiple5dFullbet <
                    betDiscount.showMin5dFullbet
                ) {
                    setBelliBets({
                        ...belliBets,
                        [`5D-${index}`]: "",
                    });
                } else {
                    let newDiskon5D;
                    let value5D = defaultvalue5D;
                    newDiskon5D =
                        value5D > 0
                            ? (value5D * betDiscount.showMultiple5dFullbet * betDiscount.showDisc5dFullbet) /
                            100
                            : 0;

                    let newBolakBalik;
                    newBolakBalik = value5D * betDiscount.showMultiple5dFullbet - newDiskon5D;
                    setBolakBalik({
                        ...bolakBalik,
                        [index]: newBolakBalik,
                    });
                    setBelliBets({
                        ...belliBets,
                        [`5D-${index}`]: defaultvalue5D,
                    });
                }
            }
        }
    };

    useEffect(() => {
        if (newIndexFocus) {
            colRef.current[newIndexFocus].focus();
        }
    }, [newIndexFocus]);

    const updateBetNumber = () => {
        let newValue = [...values];
        let betVal = "";
        let allBetsFilled = true;
        if (typeof bets["bets" + rowInd] != "undefined") {
            if (bets["bets" + rowInd] != "" && bets["bets" + rowInd].length >= 5) {
                newValue[rowInd] = bets["bets" + rowInd];
            } else {
                if (bets["bets" + rowInd]) {
                    newValue[rowInd] = undefined;
                }
            }
        }
        setValues(newValue);
    };

    useEffect(() => {
        updateBetNumber();
    }, [bets, belliBets]);

    const updateMobileBets = () => {
        let newValue = [...values];
        if (typeof mobbets["mobbets" + rowInd] != "undefined") {
            if (
                mobbets["mobbets" + rowInd] != "" &&
                mobbets["mobbets" + rowInd].length >= 5
            ) {
                newValue[rowInd] = mobbets["mobbets" + rowInd];
            } else {
                if (mobbets["mobbets" + rowInd]) {
                    newValue[rowInd] = undefined;
                }
            }
        }
        setValues(newValue);
    };

    useEffect(() => {
        updateMobileBets();
    }, [mobbets, belliBets, mobile4Digit]);


    const handleFocusInput = (e, rowIndex, type) => {
        setRowInd(rowIndex);
        updateBetNumber();
        updateMobileBets();
        const { name, value } = e.target;
        if (value === "") {
            if (defaultValue && type == "6D") {
                setBelliBets((prevBelli) => ({
                    ...prevBelli,
                    [name]: defaultValue,
                }));
            } else if (defaultvalue5D && type == "5D") {
                setBelliBets((prevBelli) => ({
                    ...prevBelli,
                    [name]: defaultvalue5D,
                }));
            }
        }
        let newBets = { ...bets };
        if (
            newBets[`bets${rowIndex}0`] !== "" &&
            newBets[`bets${rowIndex}1`] !== "" &&
            newBets[`bets${rowIndex}2`] === undefined &&
            newBets[`bets${rowIndex}3`] === undefined
        ) {
            newBets[`bets${rowIndex}2`] = "";
            newBets[`bets${rowIndex}3`] = "";
            setBets(newBets);
        }
        setMobMaxValidate(1);
    };

    useEffect(() => {
        let discountVal = "";
        let maxAmount = "";
        let minAmount = "";
        if (device === "Desktop") {
            let newValuesD = "";
            let checkValidationVal = "";
            for (let k = 0; k < 6; k++) {
                if (bets["bets" + rowInd + "" + k] != "X") {
                    newValuesD = newValuesD + bets["bets" + rowInd + "" + k];
                }
                checkValidationVal =
                    checkValidationVal +
                    (bets["bets" + rowInd + "" + k] !== ""
                        ? bets["bets" + rowInd + "" + k]
                        : "X");
            }

            let expCheckVal = checkValidationVal.split("");

            if (newValuesD.length == 5) {
                if (
                    expCheckVal[0] != "X" &&
                    expCheckVal[1] != "X" &&
                    expCheckVal[2] != "X" &&
                    expCheckVal[3] != "X" &&
                    expCheckVal[4] != "X" &&
                    expCheckVal[5] == "X"
                ) {
                    maxAmount = betDiscount.showMax5dFullbet;
                    minAmount = betDiscount.showMin5dFullbet;
                }
                discountVal = betDiscount.showDisc5dFullbet;
            } else if (newValuesD.length == 6) {
                maxAmount = betDiscount.showMax6dFullbet;
                minAmount = betDiscount.showMin6dFullbet;
                discountVal = betDiscount.showDisc6dFullbet;
            } else {
                //
            }
            let newMaxAmount;
            if (betDiscount.userBetLimitPerc) {
                newMaxAmount =
                    (maxAmount * betDiscount.userBetLimitPerc.tg_limit_percent) / 100;
            }
            setMaxtAmountValue(newMaxAmount);
            setMinAmountValue(minAmount);
            setDiscountValue(discountVal);
        }
    }, [bets, belliBets]);

    useEffect(() => {
        if (device === "Desktop") {
            if (
                defaultValue !== "" &&
                belliBets[rowInd] !== "" &&
                belliBets[rowInd] != undefined
            ) {
                if (
                    values[rowInd] !== undefined &&
                    mobMaxValidate > 0 &&
                    maxAmountValue > 0
                ) {
                    if (belliBets[rowInd] * betDiscount.showMultiple5dFullbet > maxAmountValue) {
                        setBelliBets({
                            ...belliBets,
                            [rowInd]: "",
                        });
                        setBbelli((prevBelli) => ({
                            ...prevBelli,
                            [rowInd]: "",
                        }));
                        setBolakBalik({
                            ...bolakBalik,
                            [rowInd]: "",
                        });

                        setDiskon({
                            ...diskon,
                            [rowInd]: "",
                        });
                        setErrorMessage(props.t("you_have_reached_max_bet_value"));
                        setShowErrorPopup(true);
                    } else if (

                        belliBets[rowInd] * betDiscount.showMultiple5dFullbet <
                        minAmountValue
                    ) {
                        setBelliBets({
                            ...belliBets,
                            [rowInd]: "",
                        });
                        setBbelli((prevBelli) => ({
                            ...prevBelli,
                            [rowInd]: "",
                        }));
                        setBolakBalik({
                            ...bolakBalik,
                            [rowInd]: "",
                        });

                        setDiskon({
                            ...diskon,
                            [rowInd]: "",
                        });
                        localStorage.getItem("I18N_LANGUAGE") == "en"
                            ? setErrorMessage(
                                `Minimal bet ${values[rowInd].split("").filter((item) => item !== "X")
                                    .length + "D"
                                } is 1`
                            )
                            : setErrorMessage(
                                `Minimal taruhan ${values[rowInd].split("").filter((item) => item !== "X")
                                    .length + "D"
                                } adalah 1`
                            );
                        setShowErrorPopup(true);
                    } else {
                        let value = belliBets[rowInd]
                            ? belliBets[rowInd]
                            : parseInt(defaultValue);
                        const newDiskon =
                            (value * betDiscount.showMultiple5dFullbet * dicountValue) / 100;
                        const newBolakBalik = value * betDiscount.showMultiple5dFullbet - newDiskon;
                        setBbelli((prevBelli) => ({
                            ...prevBelli,
                            [rowInd]: parseInt(value) * betDiscount.showMultiple5dFullbet,
                        }));
                        setBolakBalik((prevBolakBalik) => ({
                            ...prevBolakBalik,
                            [rowInd]: newBolakBalik,
                        }));
                        setDiskon((prevDiskon) => ({
                            ...prevDiskon,
                            [rowInd]: newDiskon,
                        }));
                    }
                } else {
                    if (dicountValue === 0 && belliBets[rowInd] !== "") {
                        setBelliBets({
                            ...belliBets,
                            [rowInd]: "",
                        });
                        // localStorage.getItem("I18N_LANGUAGE") == "en"
                        //   ? setErrorMessage(`Minimal bet 4D is 1`)
                        //   : setErrorMessage(`Minimal taruhan 4D adalah 1`);
                        // setShowErrorPopup(true);
                    }
                }
            }
        } else {
            if (
                (defaultValue !== "" &&
                    belliBets[`6D-${rowInd}`] !== "" &&
                    belliBets[`6D-${rowInd}`] !== undefined) ||
                (defaultvalue5D !== "" &&
                    belliBets[`5D-${rowInd}`] !== "" &&
                    belliBets[`5D-${rowInd}`] !== undefined)
            ) {
                let max6DValue;
                let max5DValue;
                if (
                    belliBets[`6D-${rowInd}`] &&
                    belliBets[`6D-${rowInd}`] !== undefined
                ) {
                    max6DValue = belliBets[`6D-${rowInd}`] * betDiscount.showMultiple6dFullbet;
                }
                if (
                    belliBets[`5D-${rowInd}`] &&
                    belliBets[`5D-${rowInd}`] !== undefined
                ) {
                    max5DValue = belliBets[`5D-${rowInd}`] * betDiscount.showMultiple5dFullbet;
                }
                if (
                    mobbets["mobbets" + rowInd] !== undefined &&
                    mobMaxValidate > 0 &&
                    maxAmountValue > 0
                ) {
                    if (max6DValue && max6DValue > betDiscount.showMax6dFullbet) {
                        setBelliBets({
                            ...belliBets,
                            [`6D-${rowInd}`]: "",
                        });
                        setBbelli((prevBelli) => ({
                            ...prevBelli,
                            [rowInd]: "",
                        }));
                        setBolakBalik({
                            ...bolakBalik,
                            [rowInd]: "",
                        });

                        setDiskon({
                            ...diskon,
                            [rowInd]: "",
                        });
                        setErrorMessage(props.t("you_have_reached_max_bet_value"));
                        setShowErrorPopup(true);
                    } else if (max5DValue && max5DValue > betDiscount.showMax5dFullbet) {
                        setBelliBets({
                            ...belliBets,
                            [`5D-${rowInd}`]: "",
                        });
                        setBbelli((prevBelli) => ({
                            ...prevBelli,
                            [rowInd]: "",
                        }));
                        setBolakBalik({
                            ...bolakBalik,
                            [rowInd]: "",
                        });

                        setDiskon({
                            ...diskon,
                            [rowInd]: "",
                        });
                        setErrorMessage(props.t("you_have_reached_max_bet_value"));
                        setShowErrorPopup(true);
                    } else if (max6DValue && max6DValue < betDiscount.showMin6dFullbet) {
                        setBelliBets({
                            ...belliBets,
                            [`6D-${rowInd}`]: "",
                        });
                        setBbelli((prevBelli) => ({
                            ...prevBelli,
                            [rowInd]: "",
                        }));
                        setBolakBalik({
                            ...bolakBalik,
                            [rowInd]: "",
                        });

                        setDiskon({
                            ...diskon,
                            [rowInd]: "",
                        });
                    } else if (max5DValue && max5DValue < betDiscount.showMin5dFullbet) {
                        setBelliBets({
                            ...belliBets,
                            [`5D-${rowInd}`]: "",
                        });
                        setBbelli((prevBelli) => ({
                            ...prevBelli,
                            [rowInd]: "",
                        }));
                        setBolakBalik({
                            ...bolakBalik,
                            [rowInd]: "",
                        });

                        setDiskon({
                            ...diskon,
                            [rowInd]: "",
                        });
                    } else {
                        let value = belliBets[rowInd]
                            ? belliBets[rowInd]
                            : parseInt(defaultValue);
                        const newDiskon =
                            (value * betDiscount.showMultiple6dFullbet * dicountValue) / 100;
                        const newBolakBalik = value * betDiscount.showMultiple6dFullbet - newDiskon;
                        setBbelli((prevBelli) => ({
                            ...prevBelli,
                            [rowInd]: value * betDiscount.showMultiple6dFullbet,
                        }));
                        setBolakBalik((prevBolakBalik) => ({
                            ...prevBolakBalik,
                            [rowInd]: newBolakBalik,
                        }));
                        setDiskon((prevDiskon) => ({
                            ...prevDiskon,
                            [rowInd]: newDiskon ? newDiskon : "0",
                        }));
                    }
                }
            }
        }
    }, [belliBets, maxAmountValue]);


    const handleInputChangeBelli = (e, rowIndex, betname, betType) => {
        setRowInd(rowIndex);
        let { name, value } = e.target;
        let multiple;
        value = value.replace(',', '.');
        let regex = '';
        if (betType == '6D') {
            if (String(betDiscount.showMin6dFullbet).length === 3) {
                regex = /^\d*([.,]\d?)?$/;
                value = dotNumberValidation(value);
            } else {
                regex = /^\d*$/;
                value = withDotValidation(value);
            }
            multiple = betDiscount.showMultiple6dFullbet
        } else if (betType == '5D') {
            if (String(betDiscount.showMin5dFullbet).length === 3) {
                regex = /^\d*([.,]\d?)?$/;
                value = dotNumberValidation(value);
            } else {
                regex = /^\d*$/;
                value = withDotValidation(value);
            }
            multiple = betDiscount.showMultiple5dFullbet
        }

        if (regex.test(value)) {
            setBelliBets({
                ...belliBets,
                [name]: value,
            });

            if (belli[rowIndex] && value == "") {
                const newBelli = { ...belli };
                delete newBelli[rowIndex];
                setBbelli(newBelli);
            } else {
                setBbelli({
                    ...belli,
                    [rowIndex]: value * multiple,
                });
            }
        }
    };

    const fixDecimal = value => {
        if (Array.isArray(value)) {
            return value.map(item => fixDecimal(item));
        }
        return !isNaN(value) ? parseFloat(parseFloat(value).toFixed(1)) : value;
    };

    useEffect(() => {
        let rowBet;
        if (device === "Desktop") {
            rowBet = bets["bets" + rowInd];
        } else {
            rowBet = mobbets["mobbets" + rowInd];
        }
        if (bolBalikRow.filter((item) => item !== undefined).length > 0) {
            let newTotalBetAmount = mobileTotalBetCalculate("5D6D", rowBet, belliBets, rowInd, betDiscount, true, bolBalikRow, bolBalikRowALL, values, "fullBet", device)

            if (device === "Desktop" && bolBalikRow.filter(item => item !== undefined).length > 0) {
                setBBPayAmount(fixDecimal(newTotalBetAmount[0]))
                setTotalBetAmount(fixDecimal(newTotalBetAmount[2]))
                setDiskon(fixDecimal(newTotalBetAmount[1]))
            }
            else {
                setTotalBetAmount(fixDecimal(newTotalBetAmount[0]))
                setDiskon(fixDecimal(newTotalBetAmount[1]))

            }
        }
        else {
            setBBPayAmount(0)
            let newTotalBetAmount = 0;
            const valBelli = Object.entries(belliBets).filter(
                ([key, value]) => value !== undefined && value !== ""
            );

            if (valBelli.length > 0) {
                newTotalBetAmount = totalBetAmount;
            } else {
                newTotalBetAmount = 0;
            }

            newTotalBetAmount = mobileTotalBetCalculate("5D6D", rowBet, belliBets, rowInd, betDiscount, false, bolBalikRow, bolBalikRowALL, values, "fullBet", device)

            if (device === "Desktop") {
                setTotalBetAmount(fixDecimal(newTotalBetAmount[1]))
                setDiskon(fixDecimal(newTotalBetAmount[2]))
            }
            else {
                setTotalBetAmount(fixDecimal(newTotalBetAmount[0]))
                setDiskon(fixDecimal(newTotalBetAmount[1]))
            }
        }
    }, [belliBets, values, bolBalikRow]);

    const handleBelliChangeBlur = (e, rowIndex, type) => {
        let { name, value } = e.target;
        value = value.replace(',', '.');
        let regex = '';
        if (type == '6D') {
            if (String(betDiscount.showMin6dFullbet).length === 3) {
                regex = /^\d*([.,]\d?)?$/;
                value = dotNumberBlurValidation(value);
            } else {
                regex = /^\d*$/;
                value = withDotValidation(value);
            }
        } else if (type == '5D') {
            if (String(betDiscount.showMin5dFullbet).length === 3) {
                regex = /^\d*([.,]\d?)?$/;
                value = dotNumberBlurValidation(value);
            } else {
                regex = /^\d*$/;
                value = withDotValidation(value);
            }
        }

        setMobile4Digit(1)
        updateBetNumber();
        let bet;

        if (device === "Desktop") {
            bet = bets["bets" + rowInd];
        } else {
            bet = mobbets["mobbets" + rowInd];
        }
        const isValid = (betNumber) => {
            return betNumber !== undefined;
        };
        const isBelliValid = (belliBet) => {
            return belliBet !== "" && belliBet !== undefined;
        };
        if (isValid(bet) && bet.length == 6 && type == "6D") {
            if (isBelliValid(belliBets[`6D-${rowInd}`])) {
                if (
                    belliBets[`6D-${rowInd}`] * betDiscount.showMultiple5dFullbet >
                    betDiscount.showMax6dFullbet
                ) {
                    setBelliBets((prevBeli) => {
                        const updateBelliBet = { ...prevBeli };
                        updateBelliBet[`6D-${rowInd}`] = "";
                        return updateBelliBet;
                    });
                    setErrorMessage(props.t("you_have_reached_max_bet_value"));
                    setShowErrorPopup(true);
                    return;
                } else if (belliBets[`6D-${rowInd}`] * betDiscount.showMultiple6dFullbet < betDiscount.showMin6dFullbet) {
                    setBelliBets({
                        ...belliBets,
                        [`6D-${rowInd}`]: "",
                    });
                    setBbelli((prevBelli) => ({
                        ...prevBelli,
                        [`6D-${rowInd}`]: "",
                    }));
                    setBolakBalik({
                        ...bolakBalik,
                        [`6D-${rowInd}`]: "",
                    });

                    setDiskon({
                        ...diskon,
                        [`6D-${rowInd}`]: "",
                    });
                    localStorage.getItem("I18N_LANGUAGE") == "en"
                        ? setErrorMessage(
                            `Minimal bet ${values[rowInd].split("").filter((item) => item !== "X")
                                .length + "D"
                            } is 1`
                        )
                        : setErrorMessage(
                            `Minimal taruhan ${values[rowInd].split("").filter((item) => item !== "X")
                                .length + "D"
                            } adalah 1`
                        );
                    setShowErrorPopup(true);
                }
                else if (belliBets[`6D-${rowInd}`] == 0 && belliBets[`6D-${rowInd}`] !== undefined && belliBets[`6D-${rowInd}`] !== '') {
                    setBelliBets({
                        ...belliBets,
                        [`6D-${rowInd}`]: "",
                    });
                    setBbelli((prevBelli) => ({
                        ...prevBelli,
                        [rowInd]: "",
                    }));
                    setBolakBalik({
                        ...bolakBalik,
                        [rowInd]: "",
                    });
                }
            }
        } else if (isValid(bet) && bet.length >= 5 && type == "5D") {
            if (isBelliValid(belliBets[`6D-${rowInd}`]) && bet.length == 6) {
                setBelliBets({
                    ...belliBets,
                    [`6D-${rowInd}`]: "",
                });
            }
            if (isBelliValid(belliBets[`5D-${rowInd}`])) {
                if (
                    belliBets[`5D-${rowInd}`] * betDiscount.showMultiple5dFullbet >
                    betDiscount.showMax5dFullbet
                ) {
                    setBelliBets({
                        ...belliBets,
                        [`5D-${rowInd}`]: "",
                    });
                    setErrorMessage(props.t("you_have_reached_max_bet_value"));
                    setShowErrorPopup(true);
                    return;
                }
                else if (belliBets[`5D-${rowInd}`] * betDiscount.showMultiple5dFullbet < betDiscount.showMin5dFullbet) {
                    setBelliBets({
                        ...belliBets,
                        [`5D-${rowInd}`]: "",
                    });
                    setBbelli((prevBelli) => ({
                        ...prevBelli,
                        [`5D-${rowInd}`]: "",
                    }));
                    setBolakBalik({
                        ...bolakBalik,
                        [`5D-${rowInd}`]: "",
                    });

                    setDiskon({
                        ...diskon,
                        [`5D-${rowInd}`]: "",
                    });
                    localStorage.getItem("I18N_LANGUAGE") == "en"
                        ? setErrorMessage(
                            `Minimal bet ${values[rowInd].split("").filter((item) => item !== "X")
                                .length + "D"
                            } is 1`
                        )
                        : setErrorMessage(
                            `Minimal taruhan ${values[rowInd].split("").filter((item) => item !== "X")
                                .length + "D"
                            } adalah 1`
                        );
                    setShowErrorPopup(true);
                }
                else if (belliBets[`5D-${rowInd}`] * betDiscount.showMultiple5dFullbet < betDiscount.showMin5dFullbet && belliBets[`5D-${rowInd}`] == 0 && belliBets[`5D-${rowInd}`] !== undefined) {
                    setBelliBets({
                        ...belliBets,
                        [`5D-${rowInd}`]: "",
                    });
                }
            }
        }
        e.target.value = value;
        handleInputChangeBelli(e, rowIndex, "Belli", type);
    };

    useEffect(() => {
        setAngaka([]);
        setAngakaBB([]);
        let newAngaka = [];
        let newAngakaBB = [];
        let arraMatch = [];
        const allBolakBalik = bolBalikRow.filter(item => item !== undefined)

        if (allBolakBalik.length > 0) {
            newAngaka = [];
            newAngakaBB = [];

            values.forEach((val, index) => {
                let isChecked = false; // Initialize a flag to check if any item is checked
                if (val !== undefined) {
                    let item6D;
                    let item5D;
                    if (val.length == 6) {
                        item6D = val;
                        item5D = val.replace(/^\d/, "X");
                    } else if (val.length == 5) {
                        item5D = val;
                    }

                    bolBalikRow.forEach((item) => {
                        if (item === index) {
                            arraMatch.push(val);
                            if (
                                item6D &&
                                belliBets[`6D-${index}`] !== "" &&
                                !Number.isNaN(belliBets[`6D-${index}`]) &&
                                belliBets[`6D-${index}`] !== null &&
                                belliBets[`6D-${index}`] !== undefined
                            ) {
                                newAngakaBB.push([val, belliBets[`6D-${index}`], "success"]);
                            }
                            if (
                                item5D &&
                                belliBets[`5D-${index}`] !== "" &&
                                !Number.isNaN(belliBets[`5D-${index}`]) &&
                                belliBets[`5D-${index}`] !== null &&
                                belliBets[`5D-${index}`] !== undefined
                            ) {
                                newAngakaBB.push([item5D, belliBets[`5D-${index}`], "success"]);
                            }

                            isChecked = true; // Set the flag to true if the item is checked
                        }
                    });

                    if (!isChecked && item6D !== undefined && belliBets[`6D-${index}`] !== "" && belliBets[`6D-${index}`] !== undefined) {
                        newAngaka.push([item6D, belliBets[`6D-${index}`], "success"]);
                    }
                    if (!isChecked && item5D !== undefined && belliBets[`5D-${index}`] !== "" && belliBets[`5D-${index}`] !== undefined) {
                        newAngaka.push([item5D, belliBets[`5D-${index}`], "success"]);
                    }

                }
            });

            setAngakaBB(newAngakaBB);
            if (bolBalikRowALL > 0) {
                setMainButton(false);
            }

            if (arraMatch.length === values.length) {
                setAngaka([]);
            } else {
                setAngaka(newAngaka);
            }
        } else {
            // Handle the case when bolBalikRow is empty      
            values.forEach((item, index) => {
                if (item !== undefined) {
                    let item6D;
                    let item5D;
                    if (item.length == 6) {
                        item6D = item;
                        item5D = item.replace(/^\d/, "X");
                    } else if (item.length == 5) {
                        item5D = item;
                    }

                    if (
                        item6D &&
                        belliBets[`6D-${index}`] !== "" &&
                        !Number.isNaN(belliBets[`6D-${index}`]) &&
                        belliBets[`6D-${index}`] !== null &&
                        belliBets[`6D-${index}`] !== undefined
                    ) {
                        newAngaka.push([
                            item6D,
                            belliBets[`6D-${index}`] * betDiscount.showMultiple6dFullbet,
                            "success",
                        ]);
                    }
                    if (
                        item5D &&
                        belliBets[`5D-${index}`] !== "" &&
                        !Number.isNaN(belliBets[`5D-${index}`]) &&
                        belliBets[`5D-${index}`] !== null &&
                        belliBets[`5D-${index}`] !== undefined
                    ) {
                        newAngaka.push([
                            item5D,
                            belliBets[`5D-${index}`] * betDiscount.showMultiple5dFullbet,
                            "success",
                        ]);
                    }
                }
            });
            setAngaka(newAngaka);
        }
    }, [values, bolBalikRow, belliBets]);

    function setAngakaArray() {
        if (angaka.length !== undefined) {
            if (angaka.length > 0) {
                const filteredAngaka = angaka.filter(
                    (item) =>
                        item !== undefined &&
                        item[1] !== undefined &&
                        item[1] !== "" &&
                        !Number.isNaN(item[1]) &&
                        item[1] !== null
                );
                setReqData({
                    ...reqData,
                    gameId: gameId,
                    dataangka: filteredAngaka,
                });
            } else {
                setReqData({
                    ...reqData,
                    gameId: gameId,
                    dataangka: [],
                });
            }
        }
    }

    useEffect(() => {
        setAngakaArray();
    }, [angaka]);

    useEffect(() => {
        allDataReset();
    }, [gameId]);

    useEffect(() => {
        let newAgkaArrays = [];
        bolakBalikRespArray.map((val) => {
            if (val.showNumber) {
                val.showNumber.map((value) => {
                    const newAgkaArray = [value, val.taruhan, "success"];
                    newAgkaArrays.push(newAgkaArray);
                });
            }
        });
        setCheckedBoxes(Array(bolakBalikRespArray.length).fill(true));
        setBolakBalikRespAngka(newAgkaArrays);
        setReqBBData({
            ...reqBBData,
            gameId: gameId,
            dataangka: newAgkaArrays,
        });
    }, [bolakBalikRespArray]);

    useEffect(() => {
        setReqBBData({
            ...reqBBData,
            gameId: gameId,
            dataangka: bolakBalikRespAngka,
        });
        if (bolakBalikRespArray.length > 0) {
            const newPayAmount = totalBetAmount.reduce(
                (accumulator, currentValue) => accumulator + currentValue,
                0
            );
            let addDiscount = diskon.reduce(
                (accumulator, currentValue) => accumulator + currentValue,
                0
            );
            setDiscountAmount(addDiscount);
            setPayAmount(newPayAmount);
        }
    }, [bolakBalikRespAngka]);

    const handleCheckboxToggle = (index) => {
        const newCheckedBoxes = [...checkedBoxes];
        newCheckedBoxes[index] = !newCheckedBoxes[index];
        setCheckedBoxes(newCheckedBoxes);
    };

    let i = 0;
    const updateReqData = () => {
        let newAgkaArrays = [];
        let newAngakaData = [];
        let updateNeAngaka = [];

        if (bolakBalikRespArray.length > 0) {
            setBolakBalikRespAngka([]);
            setNewAngakaD([]);
        }
        let addPayAmount = 0;
        let addDiscountAmount = 0;

        bolakBalikRespArray.forEach((val, ind) => {
            if (checkedBoxes[ind] !== false) {
                if (val.showNumber) {
                    let newAgkaArr;
                    val.showNumber.forEach((value) => {
                        let newAgkaArray;
                        if (val.type === "5D") {
                            newAgkaArray = [value, val.taruhan, "success"];
                            newAgkaArr = val.angka;
                        } else if (val.type === "6D") {
                            newAgkaArray = [value, val.taruhan, "success"];
                            newAgkaArr = val.angka;
                        }
                        newAgkaArrays.push(newAgkaArray);
                    });
                    updateNeAngaka.push(newAgkaArr);
                }
            }
        });

        if (bolakBalikRespArray.length > 0 && reqData.dataangka.length > 0) {
            reqData.dataangka.map((value) => {
                if (value[0] !== undefined && !Number.isNaN(value[1])) {
                    if (value[0].length == 5) {
                        newAngakaData.push([
                            "X" + value[0],
                            value[1] * betDiscount.showMultiple5dFullbet,
                            "success",
                        ]);
                    } else {
                        newAngakaData.push([
                            value[0],
                            value[1] * betDiscount.showMultiple6dFullbet,
                            "success",
                        ]);
                    }
                }
            });
            // }
        }

        setPayAmount(addPayAmount);
        setDiscountAmount(addDiscountAmount);
        setBolakBalikRespAngka(newAgkaArrays);
        setNewAngakaD(newAngakaData);
    };

    useEffect(() => {
        updateReqData();
    }, [checkedBoxes, reqData]);

    const hideCommonToaster = () => {
        const commonToaster = document.getElementById("commonToaster");
        if (commonToaster) {
            commonToaster.style.display = "none";
        }
    };

    const submitProcessOk = async () => {
        setShowConfirmationPopup(false);
        if (reqData.dataangka.length > 0 || reqBBData.dataangka.length > 0) {
            const processApiResponse = async (requestData) => {
                try {
                    const response = await makeAjax(
                        url.TOGEL_API.process5D6D,
                        requestData
                    );
                    if (response.status !== respStatus["SUCCESS"]) {
                        if (response.code === "sub_game_status_close") {
                            setShowGameClose(true);
                            showMessage(false);
                            hideCommonToaster();
                            dispatch(
                                setCommonConfig({ key: "subGameOnOffStatus", value: 0 })
                            );
                            return;
                        }
                        if (response.code === "market_close_err") {
                            setShowMarketClose(true);
                            showMessage(false);
                            hideCommonToaster();
                            dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
                            return;
                        }
                        if (response.code !== "validation_error") {
                            response.code
                                ? setErrorMessage(props.t(response.code))
                                : showMessage(
                                    props.t("guess_bet_wrong_place"),
                                    "error",
                                    "error"
                                );
                            setShowErrorPopup(true);
                            return false;
                        }
                        showMessage("server error No data find", "error", "error");
                        return false;
                    }
                    setRespData((prevArray) => [...prevArray, response.data]);
                    return true;
                } catch (error) {
                    showMessage(
                        "An error occurred while processing the request",
                        "error",
                        "error"
                    );
                    return false;
                }
            };

            let isSuccess = true;

            if (
                bolakBalikRespArray.length > 0 &&
                bolBalikRow.filter((item) => item !== undefined).length > 0
            ) {
                if (reqBBData.dataangka.length > 0) {
                    isSuccess = await processApiResponse(reqBBData);
                }
                if (isSuccess && newReqData.dataangka.length > 0) {
                    isSuccess = await processApiResponse(newReqData);
                }
            } else {
                isSuccess = await processApiResponse(reqData);
            }

            if (isSuccess) {
                setSuccessPopup(true);
                allDataReset();
            }
            dispatch(getUserBalance());
        } else {
            setErrorMessage(props.t("guess_bet_wrong"));
            setShowErrorPopup(true);
        }
    };

    const submitProcess = (event) => {
        const valLeng = values.filter((item) => item !== undefined);

        const valBelli = Object.entries(belliBets).filter(
            ([key, value]) => value !== undefined && value !== ""
        );
        const total = Object.values(bolakBalik).reduce(
            (total, item) => total + item,
            0
        );
        if (
            parseFloat(payAmount) > parseFloat(user_balance.coin) &&
            bolakBalikRespArray.length > 0
        ) {
            setErrorMessage(props.t("insufficiant_balance_err"));
            setShowErrorPopup(true);
        } else if (
            parseFloat(total) > parseFloat(user_balance.coin) &&
            bolakBalikRespArray.length === 0
        ) {
            setErrorMessage(props.t("insufficiant_balance_err"));
            setShowErrorPopup(true);
        } else {
            if (values.length > 0 && Object.keys(belliBets).length > 0) {
                if (valLeng.length === valBelli.length) {
                    setSuccessMessage("");
                    setShowConfirmationPopup(true);
                } else if (valLeng.length === Object.keys(bolakBalik).length) {
                    setSuccessMessage("");
                    setShowConfirmationPopup(true);
                } else {
                    setSuccessMessage("");
                    setShowConfirmationPopup(true);
                }
            } else {
                setErrorMessage(props.t("guess_bet_wrong"));
                setShowErrorPopup(true);
            }
        }
    };

    const handleDeafultInputBlur = (e, betType) => {
        let value = e.target.value;
        value = value.replace(',', '.');
        let regex = '';
        if (String(betDiscount.showMin6dFullbet).length === 3) {
            regex = /^\d*([.,]\d?)?$/;
            value = dotNumberBlurValidation(value);
        } else {
            regex = /^\d*$/;
            value = withDotValidation(value);
        }
        if (regex.test(value)) {
            setDefaultvalue(value);
        }
    }

    const handleDeafultInputBlur5D = (e, betType) => {
        let value = e.target.value;
        value = value.replace(',', '.');
        let regex = '';

        if (String(betDiscount.showMin5dFullbet).length === 3) {
            regex = /^\d*([.,]\d?)?$/;
            value = dotNumberBlurValidation(value);
        } else {
            regex = /^\d*$/;
            value = withDotValidation(value);
        }
        if (regex.test(value)) {
            setDefaultvalue5D(value)
        }
    }

    const handleDeafultInputChange = (e, betType) => {
        let value = e.target.value;
        value = value.replace(',', '.');
        let regex = '';
        if (String(betDiscount.showMin6dFullbet).length === 3) {
            regex = /^\d*([.,]\d?)?$/;
            value = dotNumberValidation(value);
        } else {
            regex = /^\d*$/;
            value = withDotValidation(value);
        }

        if (regex.test(value)) {
            setDefaultvalue(value);
        }
    };

    const handleDeafultInputChange5D = (e, betType) => {
        let value = e.target.value;
        value = value.replace(',', '.');
        let regex = '';
        if (String(betDiscount.showMin5dFullbet).length === 3) {
            regex = /^\d*([.,]\d?)?$/;
            value = dotNumberValidation(value);
        } else {
            regex = /^\d*$/;
            value = withDotValidation(value);
        }
        if (regex.test(value)) {
            setDefaultvalue5D(value);
        }
    };

    const handleRowsToShowChange = (e) => {
        setRowsToShow(parseInt(e.target.value, 10));
    };

    useEffect(() => {
        setBeliDisabled((prevBeliDisabled) => {
            if (prevBeliDisabled !== false) {
                return [...prevBeliDisabled, ...Array(rowsToShow).fill(true)];
            } else {
                return prevBeliDisabled.slice(0, rowsToShow);
            }
        });
        setBeliDisabled5D((prevBeliDisabled) => {
            if (prevBeliDisabled !== false) {
                return [...prevBeliDisabled, ...Array(rowsToShow).fill(true)];
            } else {
                return prevBeliDisabled.slice(0, rowsToShow);
            }
        });
    }, [rowsToShow]);

    const allDataReset = () => {
        setBets({});
        setBelliBets({});
        setMobBets({});
        setValues([]);
        setBbelli({});
        setDiskon({});
        setBolakBalik({});
        setReqData(initialAngaka);
        setNewReqData(initialAngaka);
        setReqBBData(initialAngaka);
        setNewAngakaD([]);
        setBolakBalikRespArray([]);
        setBolakBalikRespAngka([]);
        setBolBalikRow([]);
        setBolBalikRowAll(0);
        setDefaultvalue("");
        setDefaultvalue5D("");
        setBeliDisabled(Array(rowsToShow).fill(true));
        setBeliDisabled5D(Array(rowsToShow).fill(true));
        setBeliDisabled2D(Array(rowsToShow).fill(true));
        document.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
            checkbox.checked = false;
        });
        setProbabilityTable(false);
        setMainButton(true);
        setTotalAmount(0);
        setBBPayAmount(0);
        setTotalBetAmount([]);
    };

    //new/////
    const handleSelectAll = (e) => {
        const isChecked = e.target.checked;
        const updatedBeliDisabled = [...beliDisabled];
        const newBets = { ...bets };
        const newMobBets = { ...mobbets };
        const newValues = [...values];
        const newBelli = { ...belli };
        const newBelliBets = { ...belliBets };
        const newDiskon = { ...diskon };
        const newBolak = { ...bolakBalik };

        const updatedBolBalikRow = [];

        document
            .querySelectorAll('input[type="checkbox"].chk_bb')
            .forEach((checkbox, index) => {
                checkbox.checked = isChecked;
                if (isChecked) {
                    setBolBalikRowAll(1);
                    if (newValues[index] && newBelliBets[index] !== undefined) {
                        updatedBeliDisabled[index] = false;
                        updatedBolBalikRow.push(index);
                        // Ensure the state updates for selected items
                        newBets[`bets${index}0`] = newBets[`bets${index}0`] || ""; // Set any initial required state
                        newBets[`bets${index}1`] = newBets[`bets${index}1`] || "";
                        newBets[`bets${index}2`] = newBets[`bets${index}2`] || "";
                        newBets[`bets${index}3`] = newBets[`bets${index}3`] || "";
                        newMobBets[index] = newMobBets[index] || "";
                        newValues[index] = newValues[index] || "";
                        newBelli[index] = newBelli[index] || "";
                        newBelliBets[index] = newBelliBets[index] || "";
                        newDiskon[index] = newDiskon[index] || "";
                        newBolak[index] = newBolak[index] || "";
                    } else {
                        updatedBolBalikRow.push(index);
                    }
                } else {
                    setBolBalikRowAll(0);
                }
            });

        if (!isChecked) {
            setBolBalikRow([]); // Clear bolBalikRow if not checked
        } else {
            setBolBalikRow(updatedBolBalikRow); // Set bolBalikRow with updated indexes
        }

        setBets(newBets);
        setMobBets(newMobBets);
        setValues(newValues);
        setBbelli(newBelli);
        setBelliBets(newBelliBets);
        setDiskon(newDiskon);
        setBolakBalik(newBolak);
        setBeliDisabled(updatedBeliDisabled);
        setMainButton(!isChecked); // Enable or disable the main button based on the state
    };

    // Ensure checkInputHandler function also updates bolBalikRow accordingly
    const checkInputHandler = (e, rowIndex, columnName) => {
        setRowInd(rowIndex);
        let newBolakBalikRow = [...bolBalikRow];
        let checkVal = document.getElementById("checkValue" + rowIndex);
        if (checkVal.checked) {
            setMainButton(false);
            values.forEach((_, ind) => {
                if (newBolakBalikRow[ind] === undefined) {
                    newBolakBalikRow[ind] = undefined;
                }
            });
            newBolakBalikRow[rowIndex] = rowIndex;
            setBolBalikRow(newBolakBalikRow);
        } else {
            setMainButton(true);
            if (bolBalikRowALL > 0) {
                newBolakBalikRow[rowIndex] = undefined;
                setBolBalikRow(newBolakBalikRow);
            } else {
                newBolakBalikRow[rowIndex] = undefined;
                setBolBalikRow(newBolakBalikRow);
            }
        }
        let rowBet;
        if (device === "Desktop") {
            rowBet = bets["bets" + rowInd];
        } else {
            rowBet = mobbets["mobbets" + rowInd];
        }

        // if (device === "Mobile") {   
        if (newBolakBalikRow.filter((item) => item !== undefined).length > 0) {
            const updateAmount = mobileTotalBetCalculate("5D6D", rowBet, belliBets, rowIndex, betDiscount, true, newBolakBalikRow, bolBalikRowALL, values, "fullBet", device)

            if (device === "Desktop") {
                setBBPayAmount(updateAmount[0]);
                setTotalBetAmount(updateAmount[2]);
                setDiskon(updateAmount[1]);
            } else {
                setTotalBetAmount(updateAmount[0]);
                setDiskon(updateAmount[1]);
            }
        } else {
            setBBPayAmount(0);
        }
        // }
    };

    useEffect(() => {
        setNewReqData({
            ...newReqData,
            gameId: gameId,
            dataangka: newAngakaD,
        });
    }, [newAngakaD]);

    const submitProcessBB = (e) => {
        setProbabilityTable(false);
        setBolakBalikRespArray([]);
        setTotalAmount(0);
        let index = 1;
        // return
        if (angakaBB.length > 0) {
            if (Object.keys(belliBets).length > 0) {
                values.map((val, ind) => {
                    if (val !== undefined) {
                        let item6D;
                        let item5D;
                        let bolakArray = [];
                        let belliArray = [];
                        let multiple;
                        if (val.length == 6) {
                            if (device === "Desktop") {
                                item6D = val;
                                item5D = val.replace(/^\d/, "X");
                            } else {
                                item6D = val;
                                item5D = val.replace(/^\d/, "");
                            }
                            bolakArray = [item6D, item5D];
                            belliArray = [
                                belliBets[`6D-${ind}`] !== undefined
                                    ? belliBets[`6D-${ind}`]
                                    : "",
                                belliBets[`5D-${ind}`] !== undefined
                                    ? belliBets[`5D-${ind}`]
                                    : "",
                            ];
                            multiple = betDiscount.showMultiple6dFullbet;
                        } else if (val.length == 5) {
                            if (device === "Desktop") {
                                item5D = "X" + val;
                            } else {
                                item5D = val;
                            }
                            bolakArray = ["", item5D];
                            belliArray = ["", belliBets[`5D-${ind}`]];
                            multiple = betDiscount.showMultiple5dFullbet;
                        }

                        bolakArray.map((data, chInd) => {
                            if (
                                data !== "" &&
                                belliArray[chInd] !== "" &&
                                belliArray[chInd] !== undefined &&
                                !Number.isNaN(belliArray[chInd]) &&
                                belliArray[chInd] !== null
                            ) {
                                if (
                                    ind === bolBalikRow[ind] &&
                                    bolBalikRow[ind] !== undefined
                                ) {
                                    const action = "generate";
                                    const reqBBData = {
                                        action: action,
                                        gameId: gameId,
                                        gameType: "bolak-balik",
                                        betTogelAuth: "betTogelAuth",
                                        allowPartner: null,
                                        checklistid: ++index,
                                        dataangka: [data, belliArray[chInd], "success"],
                                        mobBets: (device === "Desktop") ? 0 : 1,
                                        multiple: multiple,
                                    };
                                    bolakBalikSubmit(reqBBData);
                                } else {
                                    const action = "generate5D6D";
                                    const reqBBData = {
                                        action: action,
                                        gameId: gameId,
                                        gameType: "bolak-balik",
                                        betTogelAuth: "betTogelAuth",
                                        allowPartner: null,
                                        checklistid:
                                            index + chInd == index
                                                ? index + chInd + ind
                                                : index + chInd,
                                        dataangka: [data, belliArray[chInd], "success"],
                                        mobBets: (device === "Desktop") ? 0 : 1,
                                        multiple: multiple,
                                    };
                                    bolakBalikSubmit(reqBBData);
                                }
                            }
                        });
                    }
                });
                setMainButton(true);
            } else {
                setErrorMessage(props.t("guess_bet_wrong"));
                setShowErrorPopup(true);
            }
        } else {
            if (values.length > 0) {
                if (angaka.length > 0) {
                    let newDataAngaka = reqData.dataangka;
                    newDataAngaka.map((item, ind) => {
                        item[1] = item[1] * betDiscount.showMultiple6dFullbet;
                    });
                    setReqData({
                        ...reqData,
                        dataangka: newDataAngaka,
                    });
                    setSuccessMessage("");
                    setShowConfirmationPopup(true);
                } else {
                    setErrorMessage(props.t("guess_bet_wrong"));
                    setShowErrorPopup(true);
                }
            } else {
                document
                    .querySelectorAll('input[type="checkbox"]')
                    .forEach((checkbox) => {
                        checkbox.checked = false;
                    });
                setBolBalikRow([]);
                setMainButton(true);
                setBolBalikRowAll(0);
            }
        }
    };

    const bolakBalikSubmit = (bbData) => {
        makeAjax(url.TOGEL_API.processBolakBalik5D6D, bbData).then((response) => {
            if (response.status !== respStatus["SUCCESS"]) {
                if (response.code === "sub_game_status_close") {
                    setShowGameClose(true);
                    showMessage(false);
                    hideCommonToaster();
                    dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
                    return;
                }
                if (response.code === "market_close_err") {
                    setShowMarketClose(true);
                    showMessage(false);
                    hideCommonToaster();
                    dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
                    return;
                }
                if (response.code !== "validation_error") {
                    response.code
                        ? showMessage(props.t(response.code), "error", "error")
                        : showMessage(props.t("guess_bet_wrong_place"), "error", "error");
                    return;
                }
                showMessage("server error No data find", "error", "error");
                return;
            }
            setBolakBalikRespArray((prevArray) => [...prevArray, response.data]);
            setTotalAmount((prevTotal) => {
                const newTotal =
                    prevTotal +
                    response.data.taruhan *
                    (typeof response.data.showNumber != "undefined"
                        ? response.data.showNumber.length
                        : 1);
                return newTotal;
            });
            setProbabilityTable(true);
            setMainButton(true);
        });
    };

    const handlePopupClose = () => {
        setRespData([]);
        setSuccessPopup(false);
        setProbabilityTable(false);
        allDataReset();
        setTotalAmount(0);
        setBBPayAmount(0);
        setTotalBetAmount([]);
    };

    const hanldeConfirmationPopupClose = () => {
        setShowConfirmationPopup(false);
        setShowCancelledPopup(true);
    };
    useEffect(() => {
        if (device === "Mobile" && probabilityTable) {
            totaldiv.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    }, [bolakBalikRespArray, device]);

    return (
        <>
            {showGameClose ? (
                <GameClosedPopup />
            ) : showMarketClose ? (
                <MarketClose />
            ) : (
                <>
                    <div className="container">
                        {/* {device === "Mobile" && ( */}
                        <CommonBetHeader
                            rowsToShow={rowsToShow}
                            handleRowsToShowChange={handleRowsToShowChange}
                            bbPayAmount={bbPayAmount}
                            totalBetAmount={totalBetAmount}
                        />
                        {/* )} */}
                        <table className="bet-diskon-table">
                            <thead
                            // ref={resetRef}
                            >
                                {device === "Desktop" ? (
                                    <>
                                        <tr className="Heading betheading">
                                            <th>{props.t("no.")}</th>
                                            <th className={`guess-bet custom-tooltip-wrapper ${currentStep === 2 ? "highlighted" : ""}`}>
                                                {props.t("guess")}
                                                {currentStep === 2 && <CoachMarkPopup />
                                                }

                                            </th>

                                            <th className={`d-flex align-right ${currentStep === 5 ? "highlighted" : ""}`}>
                                                <input
                                                    type="text"
                                                    autoComplete="off"
                                                    placeholder="Auto Bet"
                                                    value={defaultValue}
                                                    onChange={(e) => handleDeafultInputChange(e, "6D")}
                                                    onBlur={(e) => handleDeafultInputBlur(e, "6D")}
                                                    inputMode="decimal"
                                                    pattern="[0-9]*[.,]?[0-9]**"
                                                />
                                            </th>
                                            <th className={`auto-bet custom-tooltip-wrapper ${currentStep === 5 ? "highlighted" : ""}`}>
                                                <input
                                                    type="text"
                                                    autoComplete="off"
                                                    placeholder="Auto Bet"
                                                    value={defaultvalue5D}
                                                    onChange={(e) => handleDeafultInputChange5D(e, "5D")}
                                                    onBlur={(e) => handleDeafultInputBlur5D(e, "5D")}
                                                    inputMode="decimal"
                                                    pattern="[0-9]*[.,]?[0-9]**"
                                                />
                                                {currentStep === 5 && <CoachMarkPopup />}
                                            </th>

                                            <th className={`discount-tab custom-tooltip-wrapper ${currentStep === 5 ? "highlighted" : ""}`}>
                                                {props.t("discount")}
                                                {currentStep === 5 && <CoachMarkPopup />}
                                            </th>

                                            <th className={` ${currentStep === 5 ? "highlighted" : ""}`}>{props.t("pay")}</th>
                                            <th className={`check_column custom-tooltip-wrapper ${currentStep === 6 ? "highlighted" : ""}`}>
                                                {props.t("BB")}
                                                <div>
                                                    <input
                                                        type="checkbox"
                                                        onClick={(e) => handleSelectAll(e)}
                                                    />
                                                </div>
                                                {currentStep === 6 && <CoachMarkPopup />}
                                            </th>
                                        </tr>
                                        {currentStep === 2 && <div className="custom-overlay"></div>}
                                        {currentStep === 5 && <div className="custom-overlay"></div>}
                                        {currentStep === 6 && <div className="custom-overlay"></div>}
                                        {currentStep === 5 && <div className="custom-overlay"></div>}
                                    </>
                                ) : (
                                    <>
                                        <tr className="Heading betheading">
                                            <th>{props.t("no.")}</th>
                                            <th>{props.t("number")}</th>
                                            <th colSpan={4}>{props.t("bet")}</th>
                                        </tr>
                                        <tr ref={guessRef}>
                                            <th>&nbsp;</th>
                                            <th>&nbsp;</th>
                                            <th className={`auto-bet custom-tooltip-wrapper d-flex align-right ${currentStep === 5 ? "highlighted" : ""}`}>
                                                <input
                                                    type="text"
                                                    autoComplete="off"
                                                    placeholder="Auto Bet"
                                                    value={defaultValue}
                                                    onChange={(e) => handleDeafultInputChange(e, "6D")}
                                                    onBlur={(e) => handleDeafultInputBlur(e, "6D")}
                                                    inputMode="decimal"
                                                    pattern="[0-9]*[.,]?[0-9]**"
                                                />
                                            </th>
                                            <th className={`auto-bet custom-tooltip-wrapper ${currentStep === 5 ? "highlighted" : ""}`}>
                                                <input
                                                    type="text"
                                                    autoComplete="off"
                                                    placeholder="Auto Bet"
                                                    value={defaultvalue5D}
                                                    onChange={(e) => handleDeafultInputChange5D(e, "5D")}
                                                    onBlur={(e) => handleDeafultInputBlur5D(e, "5D")}
                                                    inputMode="decimal"
                                                    pattern="[0-9]*[.,]?[0-9]**"
                                                />
                                                {currentStep === 5 && <CoachMarkPopup />}
                                            </th>
                                            <th className={`check_column custom-tooltip-wrapper ${currentStep === 6 ? "highlighted" : ""}`} ref={bbRef}>
                                                {props.t("BB")}
                                                <div>

                                                    <input
                                                        type="checkbox"
                                                        onClick={(e) => handleSelectAll(e)}
                                                    />
                                                    {currentStep === 6 && <CoachMarkPopup />}
                                                </div>

                                            </th>
                                            {currentStep === 5 && <div className="custom-overlay"></div>}
                                            {currentStep === 6 && <div className="custom-overlay"></div>}
                                        </tr>
                                    </>
                                )}
                            </thead>
                            <tbody>
                                {[...Array(rowsToShow)].map((_, index) => (
                                    <tr
                                        key={index}
                                        className={
                                            index % 2 === 0
                                                ? "even-row td-padding"
                                                : "odd-row td-padding"
                                        }
                                    >
                                        <td>{index + 1}</td>
                                        {device === "Desktop" ? (
                                            <>
                                                <td className={`guess-bet custom-tooltip-wrapper ${currentStep === 2 ? "highlighted" : ""}`}>
                                                    <input
                                                        key={"betInput" + index}
                                                        autoComplete="off"
                                                        type="text"
                                                        maxlength="6"
                                                        name={`bets${index}`}
                                                        value={
                                                            bets[`bets${index}`] ? bets[`bets${index}`] : ""
                                                        }
                                                        onChange={(e) =>
                                                            handleInputChange(e, index, null, "Tebak")
                                                        }
                                                        onBlur={(e) => handleInputBlur(e, index, "Tebak")}
                                                        onFocus={(e) => hendleInputFocus(e, index, "Tebak")}
                                                        inputMode="numeric"
                                                    />
                                                </td>
                                            </>
                                        ) : (
                                            <>

                                                <td className={`inputs guess-bet custom-tooltip-wrapper ${currentStep === 2 ? "highlighted" : ""}`}>
                                                    <input
                                                        type="text"
                                                        maxlength="6"
                                                        autoComplete="off"
                                                        name={`mobbets${index}`}
                                                        value={
                                                            mobbets[`mobbets${index}`]
                                                                ? mobbets[`mobbets${index}`]
                                                                : ""
                                                        }
                                                        onBlur={(e) => handleInputBlur(e, index)}
                                                        onChange={(e) => handleInputChange(e, index, "Tebak")}
                                                        inputMode="numeric"
                                                        pattern="[0-9]*"
                                                    />
                                                    {currentStep === 2 && device === "Desktop" && !isPopupShown && (<CoachMarkPopup />)}
                                                    {currentStep === 2 && device === "Mobile" && index === 0 ? <CoachMarkPopup /> : ""}

                                                </td>
                                                {currentStep === 2 && index === 0 && <div className="custom-overlay"></div>}
                                            </>
                                        )}

                                        <>
                                            <td className={`inputs auto-bet custom-tooltip-wrapper ${currentStep === 5 ? "highlighted" : ""}`}>
                                                <input
                                                    type="text"
                                                    autoComplete="off"
                                                    placeholder={beliDisabled[index] == true ? "6D" : ""}
                                                    name={`6D-${index}`}
                                                    value={
                                                        belliBets[`6D-${index}`] &&
                                                            beliDisabled[index] == false
                                                            ? belliBets[`6D-${index}`]
                                                            : ""
                                                    }
                                                    ref={(el) => (colRef.current[`${index}-belli`] = el)}
                                                    onChange={(e) =>
                                                        handleInputChangeBelli(e, index, "Belli", "6D")
                                                    }
                                                    onFocus={(e) => handleFocusInput(e, index, "6D")}
                                                    disabled={beliDisabled[index]}
                                                    onBlur={(e) => handleBelliChangeBlur(e, index, "6D")}
                                                    className="input-bg"
                                                    inputMode="decimal"
                                                    pattern="[0-9]*[.,]?[0-9]**"
                                                    style={{ minWidth: 50 }}
                                                />
                                            </td>
                                            <td className={`inputs auto-bet custom-tooltip-wrapper ${currentStep === 5 ? "highlighted" : ""}`}>
                                                <input
                                                    type="text"
                                                    autoComplete="off"
                                                    placeholder={
                                                        beliDisabled5D[index] == true ? "5D Blkg" : ""
                                                    }
                                                    name={`5D-${index}`}
                                                    value={
                                                        belliBets[`5D-${index}`] &&
                                                            beliDisabled5D[index] == false
                                                            ? belliBets[`5D-${index}`]
                                                            : ""
                                                    }
                                                    ref={(el) => (colRef.current[`5D-${index}`] = el)}
                                                    onChange={(e) =>
                                                        handleInputChangeBelli(e, index, "Belli", "5D")
                                                    }
                                                    onFocus={(e) => handleFocusInput(e, index, "5D")}
                                                    disabled={beliDisabled5D[index]}
                                                    onBlur={(e) => handleBelliChangeBlur(e, index, "5D")}
                                                    className="input-bg"
                                                    inputMode="decimal"
                                                    pattern="[0-9]*[.,]?[0-9]**"
                                                    style={{ minWidth: 50 }}
                                                />
                                            </td>
                                            {device === "Desktop" && (
                                                <>
                                                    <td className={`inputs discount-tab custom-tooltip-wrapper ${currentStep === 5 ? "highlighted" : ""}`}>
                                                        <input
                                                            name={index}
                                                            readOnly
                                                            tabindex="-1"
                                                            type="text"
                                                            value={diskon[index] == 0 && totalBetAmount[index] ? "0" : ""}
                                                        />
                                                    </td>
                                                    <td className={`inputs discount-tab custom-tooltip-wrapper ${currentStep === 5 ? "highlighted" : ""}`}>
                                                        <input
                                                            name={index}
                                                            readOnly
                                                            tabindex="-1"
                                                            type="text"
                                                            value={
                                                                totalBetAmount[index]
                                                                    ? formatPrice(totalBetAmount[index])
                                                                    : ""
                                                            }
                                                        />
                                                    </td>
                                                </>
                                            )}
                                            <td className={`guess-bet custom-tooltip-wrapper ${currentStep === 6 ? "highlighted" : ""}`}>
                                                <input
                                                    tabindex="-1"
                                                    type="checkbox"
                                                    id={`checkValue${index}`}
                                                    onClick={(e) => checkInputHandler(e, index, "")}
                                                    className="chk_bb"
                                                />
                                            </td>
                                        </>
                                        {/* )} */}


                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    {probabilityTable && (
                        <div className="fourDThreeDTwoD_probability_container">
                            <div className="probability_container">
                                <table>
                                    <thead>
                                        <tr className="Heading">
                                            <th>{props.t("no.")}</th>
                                            <th></th>
                                            <th>{props.t("guess")}</th>
                                            <th>{props.t("Tipe")}</th>
                                            <th>{props.t("buy")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {bolakBalikRespArray.length == 0 ? (
                                            <tr className="table_data_empty_row">
                                                <td colSpan="11">{"data_not_found"}</td>
                                            </tr>
                                        ) : (
                                            bolakBalikRespArray.map((value, index) => (
                                                <tr
                                                    key={index}
                                                    className={index % 2 === 0 ? "even-row" : "odd-row"}
                                                >
                                                    <td>{index + 1}</td>
                                                    <td align="center">
                                                        <input
                                                            type="checkbox"
                                                            className="chk_bb"
                                                            checked={checkedBoxes[index]}
                                                            defaultChecked
                                                            onChange={() => handleCheckboxToggle(index)}
                                                        />
                                                        <span
                                                            style={{ textAlign: "center", display: "block" }}
                                                        >
                                                            {value.count}
                                                        </span>
                                                    </td>
                                                    <td
                                                        className="bet_probability_column"
                                                        style={{
                                                            textAlign: "center",
                                                            display: "block",
                                                            wordBreak: "break-word",
                                                        }}
                                                    >
                                                        {value.showNumber
                                                            ? value.showNumber.toString().replace(/,/g, " : ")
                                                            : value.angka}
                                                    </td>
                                                    <td>{value.type}</td>
                                                    <td>
                                                        <p>
                                                            <span>
                                                                {formatPrice(value.taruhan)} X{" "}
                                                                {formatPrice(
                                                                    typeof value.showNumber != "undefined"
                                                                        ? value.showNumber.length
                                                                        : 1
                                                                )}{" "}
                                                                ={" "}
                                                            </span>
                                                            {formatPrice(
                                                                parseInt(
                                                                    typeof value.showNumber != "undefined"
                                                                        ? value.showNumber.length
                                                                        : 1
                                                                ) * parseInt(value.taruhan)
                                                            )}
                                                        </p>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="betdiskon_total">
                                <div className="d-flex flex-direction-column">
                                    <div className="d-flex justify-content-space-around">
                                        {props.t("submit")}{" "}
                                        <span className="betdiskon_total_amount">
                                            {formatPrice(totalAmount)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="last_div" ref={totaldiv}>
                        <div className="left_div">
                            <p>{props.t("guess_exact_number_5d6d")}</p>
                        </div>
                        <div className="right_div"
                            ref={resetRef}
                        >
                            <ul className="button-list" >
                                {/* <li className={`reset-btx  ${currentStep === 6 ? "custom-tooltip-wrapper highlighted" : ""}`}> */}
                                <li className={`reset-btx custom-tooltip-wrapper`}
                                    style={{
                                        zIndex:
                                            currentStep === 2 || currentStep === 5 || currentStep === 6 || currentStep === 5
                                                ? -10
                                                : "auto", // Default value when no condition matches
                                    }} >

                                    <button
                                        onClick={allDataReset}
                                        // className={`reset`} 
                                        className={`reset ${currentStep === 6 ? "disabled" : ""}`}
                                        style={{ zIndex: currentStep === 6 ? 9 : "auto" }}
                                        disabled={currentStep === 6} // Disable the button
                                    >
                                        Reset
                                    </button>
                                    {currentStep === 6 && <CoachMarkPopup />}
                                    {currentStep === 6 && <div className="custom-overlay" ></div>}
                                </li>

                                {mainButton ? (
                                    <li className={`submit-btx custom-tooltip-wrapper `} style={{
                                        zIndex:
                                            currentStep === 2 || currentStep === 5 || currentStep === 6 || currentStep === 5
                                                ? -10
                                                : "auto", // Default value when no condition matches
                                    }}>

                                        <button
                                            onClick={submitProcess}
                                            // className={`submit`} 
                                            className={`submit ${currentStep === 7 ? "disabled" : ""}`}
                                            style={{ zIndex: currentStep === 7 ? 9 : "auto" }}
                                            disabled={currentStep === 7} // Disable the button

                                        >
                                            {props.t("submit")}
                                        </button>
                                        {currentStep === 7 && <CoachMarkPopup />}
                                        {currentStep === 7 && <div className="custom-overlay"></div>}
                                    </li>

                                ) : (
                                    <li>
                                        <button onClick={submitProcessBB} className="submit">
                                            {props.t("submit")}
                                        </button>
                                    </li>
                                )

                                }


                            </ul>
                        </div >
                        {showConfirmationPopup && (
                            <ConfirmBetDeskonPopup
                                onClose={hanldeConfirmationPopupClose}
                                message={succMessage}
                                submitProcessOk={submitProcessOk}
                            />
                        )}
                        {
                            showCancelledPopup && (
                                <CancelledBetDeskonPopup
                                    onClose={() => setShowCancelledPopup(false)}
                                />
                            )
                        }
                        {
                            showConfirmationDataPopup && (
                                <ConfirmDataBetDeskonPopup
                                    onClose={() => setShowConfirmationDataPopup(false)}
                                    message={succMessage}
                                    submitProcessOk={submitProcessOk}
                                />
                            )
                        }
                        {
                            successPopup && (
                                <div className="popup-overlay ">
                                    <BetSuccessPopup
                                        response={respData}
                                        onClose={handlePopupClose}
                                    />
                                </div>
                            )
                        }
                        {
                            /*---error popup --*/
                            showErrorPopup && (
                                <ErrorInnerPopup
                                    modalTitle={""}
                                    modalHeader={true}
                                    onCloseModal={() => setShowErrorPopup(false)}
                                >
                                    <ErrorPopup
                                        message={errMessage}
                                        onClose={() => setShowErrorPopup(false)}
                                    />
                                </ErrorInnerPopup>
                            )
                        }
                    </div >
                </>
            )}
        </>
    );
};

export default withTranslation()(Bet_Full);
